import { mapState } from 'vuex'
/**
 * 主题变量切换混入
 * 用于主题切换时，自动更新主题变量，主要用在必须在代码中使用主题变量的情况，例如ECharts
 * 如何使用：
 * 先引入该混入，再在代码中定义themeVarsDefine选项，在dark和default中分别列出不同风格下主题变量的值。
 * 例如：
 * export default {
 *   themeVarsDefine: {
 *     dark: {
 *       bgColor: #00f;
 *     },
 *     default: {
 *       bgColor: #fff;
 *     }
 *   }
 * }
 * 然后可以直接用以下方式使用该变量
 * export default {
 *   watch: {
 *     themeVars: function (val) {
 *       val.bgColor ...
 *     }
 *   },
 *   methods: {
 *     someFunctions: function() {
 *       this.themeVars.bgColor
 *     }
 *   }
 * }
 */
export default {
  name: 'ThemeVarsDefine',
  data() {
    return {
      themeVars: {}
    }
  },
  computed: {
    ...mapState({
      themeName: state => state.app.themeName
    })
  },
  watch: {
    '$store.state.app.themeName'(newValue) {
      if (this.$options.themeVarsDefine) {
        if (newValue === 'darkTheme') {
          this.themeVars = this.$options.themeVarsDefine.dark || {}
        } else {
          this.themeVars = this.$options.themeVarsDefine.default || {}
        }
      }
    }
  },
  mounted() {
    if (this.$options.themeVarsDefine) {
      if (this.themeName === 'darkTheme') {
        this.themeVars = this.$options.themeVarsDefine.dark || {}
      } else {
        this.themeVars = this.$options.themeVarsDefine.default || {}
      }
    }
  }
}
